import { render } from "./MyCardTabPictures.vue?vue&type=template&id=bf700bfe&scoped=true&bindings={}"
import script from "./MyCardTabPictures.vue?vue&type=script&lang=ts"
export * from "./MyCardTabPictures.vue?vue&type=script&lang=ts"

import "./MyCardTabPictures.vue?vue&type=style&index=0&id=bf700bfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bf700bfe"

export default script